import { createElement } from "react";
import Experiences, { ExperiencesProps } from "./Experiences";
import { getBoards } from "src/pods/ideas/boardCatalog";

type OuterExperiencesProps = Omit<ExperiencesProps, "boards">;

export default function ExperiencesContainer(props: OuterExperiencesProps) {
  return createElement(Experiences, { ...props, boards: getBoards() });
}
